import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { IMAGES } from "@/lib/content";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user !== false) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  const field = "w-full bg-neutral-100 border border-black/12 rounded-xl px-4 py-3 text-neutral-900 placeholder:text-neutral-300 outline-none focus:border-neutral-900";

  return (
    <>
      <Seo title="Staff Login" />
      <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden bg-transparent">
        <img src={IMAGES.lounge} alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-neutral-100" />
        <form onSubmit={submit} className="relative z-10 glass rounded-2xl p-10 w-full max-w-md">
          <div className="text-center mb-8">
            <div className="font-serif text-3xl tracking-[0.2em] text-accent">CHI-CHA</div>
            <p className="text-neutral-400 text-xs uppercase tracking-[0.3em] mt-2">Staff Dashboard</p>
          </div>
          {error && <div data-testid="login-error" className="bg-neonred/10 border border-neonred/30 text-neonred text-sm rounded-lg px-4 py-3 mb-5">{error}</div>}
          <div className="space-y-4">
            <div><label className="overline block mb-2">Email</label><input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} placeholder="admin@dcchicha.com" /></div>
            <div><label className="overline block mb-2">Password</label><input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} placeholder="••••••••" /></div>
          </div>
          <button data-testid="login-submit" disabled={loading} className="btn-gold w-full justify-center mt-7">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <Lock size={16} />} {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </>
  );
}
